import { GeografiskResultat, LocalizedName, Parti, PartiResultat } from '../../../domain'
import { createUrlFor, createUrlForParti } from '../../../routes'
import { idFrom } from '../../../api'

export type OppslutningTableItem = {
  url: string
  navn: LocalizedName
  id: string
  kortNavn?: string
  prosent?: number
  antall?: number
  endring?: number
  farge: string
  fargeSvak: string
  prioritized: boolean
}

function isVisible(showAll) {
  return (partiResultat: PartiResultat) =>
    partiResultat.parti.id !== 'BLANKE' &&
    (partiResultat.parti.kategori === 1 ||
      partiResultat.parti.kategori === 2 ||
      (partiResultat.parti.kategori === 3 &&
        (showAll ||
          (partiResultat.stemmer &&
            partiResultat.stemmer.prosent &&
            partiResultat.stemmer.prosent > 0.05))))
}

export function toOppslutningTableItem(
  partiresultater: PartiResultat[] = [],
  locale: string,
  showAll: boolean = true,
  currentParti?: Parti
): OppslutningTableItem[] {
  return partiresultater.filter(isVisible(showAll)).map(partiresultat => {
    const stemmer = partiresultat.stemmer || {}
    return {
      url: createUrlForParti(partiresultat.parti.id, locale),
      navn: partiresultat.parti.navn,
      kortNavn: partiresultat.parti.kortNavn,
      id: partiresultat.parti.id,
      prosent: stemmer.prosent,
      antall: stemmer.antall ? stemmer.antall.total : undefined,
      endring: stemmer.endring ? stemmer.endring.samme : undefined,
      farge: partiresultat.parti.farge,
      fargeSvak: partiresultat.parti.fargeSvak,
      prioritized: !!currentParti && currentParti.id === partiresultat.parti.id
    }
  })
}

export function stederTilOppslutningTableItem(
  geografiskeResultater: GeografiskResultat[],
  parti: Parti,
  locale: string
): OppslutningTableItem[] {
  return geografiskeResultater.map(resultat => {
    const stemmer = resultat.stemmer || {}
    return {
      url: createUrlFor(resultat.geografi, locale),
      navn: resultat.geografi.navn,
      id: idFrom(resultat.geografi),
      prosent: stemmer.prosent || 0,
      antall: stemmer.antall ? stemmer.antall.total : undefined,
      endring: stemmer.endring ? stemmer.endring.samme : undefined,
      farge: parti.farge,
      fargeSvak: parti.fargeSvak,
      prioritized: false
    }
  })
}
